import { memo } from 'react';
import { SearchBar } from '@/components/organisms/search-bar/search-bar';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import parseDanishDate from '@/libraries/formatters/parse-danish-date';
import styles from './header-carousel-search.module.scss';

export interface HeaderCarouselSearchProps {
  /** Search settings for the search bar */
  searchSettings: Content.Components['HeaderCarouselModuleDto']['searchSettings'];
}

const HeaderCarouselSearch = ({
  searchSettings,
}: HeaderCarouselSearchProps) => {
  if (!searchSettings) {
    return null;
  }

  const propDefaultValues =
    searchSettings.$type === 'SearchSettingsDto'
      ? {
          adultsNumber:
            searchSettings.selectedPaxDistribution?.adultsNo.toString(),
          departureDate: searchSettings.selectedDepartureDate
            ? parseDanishDate(searchSettings.selectedDepartureDate.toString())
            : undefined,
          departureId: searchSettings.selectedDepartureId?.toString(),
          destinationIds: searchSettings.selectedDestinationIds?.map(id =>
            id.toString(),
          ),
          destinationRegionIds:
            searchSettings.selectedDestinationRegionIds?.map(id =>
              id.toString(),
            ),
          durationType: searchSettings.selectedPeriodType,
        }
      : undefined;

  const basicSearchSettings =
    searchSettings as Content.Components['SearchSettingsDto'];

  const travelPortalSearchSettings =
    searchSettings.$type === 'TravelPortalSearchSettingsDto'
      ? (searchSettings as Content.Components['TravelPortalSearchSettingsDto'])
      : undefined;

  return (
    <Container className={styles.component}>
      <Row>
        <Column>
          <SearchBar
            className={styles.searchBar}
            propDefaultValues={propDefaultValues}
            searchSettings={basicSearchSettings}
            shouldNavigate
            travelPortalSearchSettings={travelPortalSearchSettings}
          />
        </Column>
      </Row>
    </Container>
  );
};

HeaderCarouselSearch.displayName = 'HeaderCarouselSearch';

export default memo(HeaderCarouselSearch);
